import React from 'react'

class TasksCounter extends React.Component {
  render() {
    return(
      <div className='timeline-item-summary'>
        <span className="task-icon"></span>
        <span className='timeline-item-count'>
          { this.props.tasksCount }
        </span>
      </div>
    )
  }
}

export default TasksCounter
